import { render, staticRenderFns } from "./SettingFeesAndLimits.vue?vue&type=template&id=93b97ae2&"
import script from "./SettingFeesAndLimits.vue?vue&type=script&lang=js&"
export * from "./SettingFeesAndLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports